import React from "react";
import "./ServicesPageStyle.scss";
import { bannerServicesTextContent } from "./constant";
import MainLayout from "../../components/MainLayout";
import SingleBannerSection from "components/SingleBannerSection";
import SlotGamesDevelopmentSection from "components/SlotGamesDevelopmentSection";
import SlotGamesSoftwareFeaturesSection from "components/SlotGamesSoftwareFeaturesSection";
import SlotGamesSoftwareSection from "components/SlotGamesSoftwareSection";
import MoreWeOfferSection from "components/MoreWeOfferSection";
import SlotGamesDevelopmentProcessSection from "components/SlotGamesDevelopmentProcessSection";
import SlotGamesDevelopmentSuperiorSection from "components/SlotGamesDevelopmentSuperiorSection";
import SlotGamesDevelopmentCompanySection from "components/SlotGamesDevelopmentCompanySection";
import ContactUsSection from "components/ContactUsSection";

const ServicesPage = () => {
  return (
    <MainLayout>
      <div className="slot-games-page">
        {bannerServicesTextContent.content.map((item, index) => (
          <SingleBannerSection
            key={index}
            bannerTitleText={item.titleText}
            bannerParaText={item.paraText}
            btnText={item.btnText}
            bannerImageSrcContact={item.imageSrcContact}
            bannerImageSrc={item.imageSrc}
          />
        ))}
        <SlotGamesDevelopmentSection />
        <SlotGamesSoftwareFeaturesSection />
        <SlotGamesSoftwareSection />
        <MoreWeOfferSection />
        <SlotGamesDevelopmentProcessSection />
        <SlotGamesDevelopmentSuperiorSection />
        <SlotGamesDevelopmentCompanySection />
        <ContactUsSection />
      </div>
    </MainLayout>
  );
};

export default ServicesPage;
